import React from 'react';
import { Card, CardBorderRadius, CardBorderStyle, CardHeaderTheme, CardTheme } from '@apply/components';
import { ActionsMenu, ActionsMenuItem } from './ActionsMenu';

export interface SummaryRow {
    key: string;
    title: string;
    subtitle?: string;
    trailing?: React.ReactNode;
    actions?: ActionsMenuItem[];
}

interface SummaryCardProps {
    id: string;
    heading: string;
    rows: SummaryRow[];
    emptyText?: string;
}

// Bordered list card used by the step summaries
export const SummaryCard: React.FC<SummaryCardProps> = ({ id, heading, rows, emptyText = 'None added yet.' }) => (
    <Card
        header={heading}
        headerTheme={CardHeaderTheme.Gray}
        theme={CardTheme.White}
        borderStyle={CardBorderStyle.Solid}
        borderRadius={CardBorderRadius.Medium}
        width='100%'
    >
        {rows.length === 0 ? (
            <div className='bp-summaryCard__empty'>{emptyText}</div>
        ) : (
            <ul className='bp-summaryCard__list'>
                {rows.map((row) => (
                    <li
                        className='bp-summaryCard__row'
                        key={row.key}
                    >
                        <div className='bp-summaryCard__text'>
                            <div className='bp-summaryCard__title'>{row.title}</div>
                            {row.subtitle && <div className='bp-summaryCard__subtitle'>{row.subtitle}</div>}
                        </div>
                        {row.trailing && <div className='bp-summaryCard__trailing'>{row.trailing}</div>}
                        {row.actions && row.actions.length > 0 && (
                            <ActionsMenu
                                id={`${id}_actions_${row.key}`}
                                items={row.actions}
                            />
                        )}
                    </li>
                ))}
            </ul>
        )}
    </Card>
);
